(function () {
  var popup = document.getElementById('popup');
  if (!popup) return;

  var shownAt = 0;

  function clearVisibleFlag() {
    try {
      localStorage.removeItem('popup-visible');
    } catch (e) {}
  }

  // The theme's own popup script re-evaluates "should I show?" on every
  // window `resize` event, and treats the `popup-visible` localStorage
  // flag (set the instant the popup opens) as a signal to show it again.
  // On mobile, the browser fires `resize` when the address bar
  // collapses on scroll, or when the on-screen keyboard opens after the
  // popup auto-focuses its own email field -- so the popup closes and
  // immediately reopens, looking like it "shows twice".
  //
  // We don't touch the vendor bundle: once the popup becomes visible we
  // just clear that flag right away, so a later resize can't be
  // mistaken for "reopen me".
  var observer = new MutationObserver(function () {
    if (popup.classList.contains('visible')) {
      clearVisibleFlag();
      shownAt = Date.now();
    }
  });

  observer.observe(popup, { attributes: true, attributeFilter: ['class'] });

  // ---------------------------------------------------------------------
  // Second, independent double-trigger path: `resize` firing BEFORE the
  // popup has ever shown once.
  //
  // Popup (assets/theme.js, class Popup, sourced from
  // ./src/javascripts/global/Popup.js) has two separate, uncoordinated
  // ways to end up calling show():
  //
  //   1. initPopup() checks shouldShowPopup() ONCE, at construction, and
  //      if eligible arms a single setTimeout (~pop-up-delay seconds)
  //      whose callback unconditionally calls setExpiry() then show().
  //      This is the intended "auto-show after N seconds" behaviour.
  //
  //   2. window.addEventListener('resize', this.onWindowResize) --
  //      registered once, for the whole page's life, completely
  //      independent of #1 -- reruns that SAME shouldShowPopup() check on
  //      every single resize event, with no debounce and no "a show is
  //      already pending" guard, and calls show() immediately if
  //      eligible.
  //
  // shouldShowPopup() ultimately reads localStorage ('wetheme-popup'),
  // which is only ever WRITTEN inside #1's own timeout callback (via
  // setExpiry()). So for the entire window between page load and that
  // timer firing, #2 sees the exact same "still eligible" answer #1
  // already saw -- and ANY resize in that window (a mobile address bar
  // collapsing, the on-screen keyboard opening, a layout reflow from
  // something loading late -- all common, and likely on a short page
  // like Contact) fires an early, extra show(). The original timer then
  // still fires later and calls show() again regardless of what happened
  // in between -- two opens from one visit, so it has to be closed
  // twice, or it reappears after being closed once.
  //
  // This is a DIFFERENT gap than the one fixed above: the fix above only
  // ever reacts to the popup having already appeared once (the 'visible'
  // class briefly toggling on), and there's nothing yet for it to react
  // to during this earlier, pre-first-show window.
  //
  // We looked at bridging that window by writing a short-lived
  // placeholder into 'wetheme-popup' ourselves (to make shouldShowPopup()
  // report "not eligible" until the real timer catches up) and rejected
  // it: that key is durable and shared across page loads, so a visitor
  // who navigates to a different page before their first page's own
  // timer ever fires leaves the placeholder behind -- and the *next*
  // page reads it as a real, still-valid expiry and never arms its own
  // timer at all. That's a real regression for ordinary multi-page
  // browsing, not just an edge case, and it doesn't show up in a
  // same-page test.
  //
  // Instead we stop the theme's resize listener from ever reaching
  // `window` in the first place, for the one production trigger that
  // actually causes the bug (a real browser `resize` event), while never
  // touching any storage at all -- so there is nothing left behind for a
  // later page load to misread.
  //
  // Popup's constructor calls window.addEventListener('resize', ...)
  // synchronously, but only once DOMContentLoaded fires (Theme's
  // onLoadAll -> load() -> new Popup(...) is one synchronous call chain,
  // no await/setTimeout in between). DOMContentLoaded only fires after
  // EVERY deferred/module <script>'s own top-level code has already run
  // -- Popup's constructor included -- regardless of the order those
  // <script> tags are listed in. So the moment this file's own top-level
  // code (below) runs, we are guaranteed to be earlier than that
  // construction, whichever <script> tag comes first in theme.liquid --
  // unlike the fix above, this one has no script-ordering requirement to
  // get right.
  //
  // We can't grab a reference to the Popup instance itself to disable
  // just its own listener directly -- it's kept as a private field on
  // the Theme instance and never exposed on `window` (`window.wetheme`
  // is populated by a one-time property copy taken immediately after
  // `new Theme()`, before `load()` has run and set `this.popup`). So
  // instead we recognise the resize *listener function* itself: Popup's
  // handler is the only `resize` listener anywhere in the theme bundle
  // whose body calls a method named shouldShowPopup (checked against
  // every window.addEventListener("resize", ...) call in theme.min.js --
  // sticky header, mega menu, sliders, Google Maps -- none of them go
  // anywhere near that name). Every other resize listener -- present or
  // future, a merchant app's included -- passes straight through
  // untouched.
  //
  // We deliberately leave the theme editor alone (window.Shopify.
  // designMode): a merchant resizing the editor preview to compare the
  // slide-up and fullscreen variants is a legitimate, if incidental, use
  // of this same resize hook, and it's not what's being reported broken.
  //
  // IMPORTANT: blocking that one addEventListener('resize', ...) call is
  // necessary but not sufficient. Popup extends the theme's generic
  // Component base class, and that base class's constructor
  // unconditionally does `theme.registerComponent(this)` -- adding the
  // instance to `theme.registeredComponents`. Theme's OWN (separate,
  // never-blocked) `window.addEventListener('resize', this.onRawResize)`
  // throttles down to `this.onResize()`, which walks every registered
  // component and calls `c.onWindowResize(...)` on each one -- Popup
  // included. That is a second, fully independent way a real resize
  // event reaches the exact same shouldShowPopup()-gated show() call,
  // completely bypassing the addEventListener block above. Both paths
  // have to be closed.
  (function neutralizePopupResizeReshow() {
    if (typeof window.addEventListener !== 'function') return;

    var realAddEventListener = window.addEventListener;

    function inThemeEditor() {
      return !!(window.Shopify && window.Shopify.designMode);
    }

    function isPopupsOwnResizeHandler(fn) {
      if (typeof fn !== 'function') return false;
      try {
        return Function.prototype.toString.call(fn).indexOf('shouldShowPopup') !== -1;
      } catch (e) {
        return false;
      }
    }

    function restore() {
      if (window.addEventListener === guardedAddEventListener) {
        window.addEventListener = realAddEventListener;
      }
    }

    // Closes the second path: find this exact same handler in Theme's
    // component registry (window.wetheme.registeredComponents is the
    // live array, not a copy -- Theme assigns it before this script
    // runs, and array contents mutate by reference) and neutralize it
    // there too, so Theme's own broadcast can no longer reach it either.
    // Matched by strict reference equality against the very listener
    // Popup's constructor just tried to attach directly, so this can
    // only ever affect that one Popup instance.
    function neutralizeInComponentRegistry(realOnWindowResize) {
      try {
        var components = window.wetheme && window.wetheme.registeredComponents;
        if (!Array.isArray(components)) return;
        for (var i = 0; i < components.length; i++) {
          if (components[i] && components[i].onWindowResize === realOnWindowResize) {
            components[i].onWindowResize = function () {};
            break;
          }
        }
      } catch (e) {}
    }

    function guardedAddEventListener(type, listener, options) {
      if (type === 'resize' && !inThemeEditor() && isPopupsOwnResizeHandler(listener)) {
        // Found the one registration we're looking for. We don't attach
        // anything in its place -- initPopup()'s own timer is already
        // the single source of truth for when the popup should actually
        // appear, so a resize is never the right trigger for that, at
        // any point in the page's life (before OR after that timer has
        // fired). Nothing else ever holds a reference to this exact
        // listener to call removeEventListener with, so there's nothing
        // to keep working here.
        restore();
        neutralizeInComponentRegistry(listener);
        return;
      }
      return realAddEventListener.apply(this, arguments);
    }

    window.addEventListener = guardedAddEventListener;

    // Belt-and-braces cleanup, not correctness: if Popup is never
    // constructed at all on a given page (the `#popup` markup renders on
    // every page, but Theme skips `new Popup(...)` on `/challenge`),
    // nothing above ever matches and we'd otherwise stay patched
    // forever. restore() is a no-op once it has already run, and every
    // non-matching call is passed straight through the whole time either
    // way, so nothing depends on this firing promptly.
    setTimeout(restore, 20000);
  })();

  // The theme also auto-focuses the popup's email field ~300ms after it
  // opens (see popupInput?.focus() in the vendor bundle). On mobile that
  // pops the on-screen keyboard uninvited: the popup is a fixed bottom
  // sheet, so the keyboard shifts it, and the visitor's next tap lands on
  // whatever moved into that spot instead of the close button -- the tap
  // gets "used up" dismissing the keyboard, so closing needs a second tap.
  //
  // Cancel only that automatic focus: a focus that lands within ~600ms of
  // the popup appearing, on a narrow/mobile screen. A real tap into the
  // field takes longer than that, so genuine typing is left alone.
  var input = popup.querySelector('input[type="email"]');
  if (input) {
    input.addEventListener('focus', function () {
      var sinceShown = Date.now() - shownAt;
      var isNarrow = window.matchMedia('(max-width: 768px)').matches;
      if (isNarrow && sinceShown >= 0 && sinceShown < 600) {
        input.blur();
      }
    });
  }
})();
